<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      row-id="inspectionCode"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
        trigger: 'row',
        checkMethod: checCheckboxkMethod,
      }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <div class="status-tag">
          <el-tag size="mini" :type="row.status">
            {{ row.v_status }}
          </el-tag>
        </div>
      </template>
      <template v-slot:auditResultType="{ row }">
        <div class="result-tag" v-if="row.auditResultType">
          <el-tag size="mini" :type="row.auditResultType">
            {{ row.v_auditResultType }}
          </el-tag>
        </div>
      </template>
      <template v-slot:purchaseMaterial="{ row }">
        <div>
          <span
            >{{ $l('table_label_fabricNo') || '编码' }}：{{
              row.fabricNo
            }}</span
          >
          <br />
          <span
            >{{ $l('table_label_fabricName') || '名称' }}：{{
              row.fabricName
            }}</span
          >
        </div>
      </template>
      <template v-slot:fabricWidth="{ row }">
        <div>
          <span
            >{{ $l('table_label_fabricWidth') || '门幅' }}：{{
              row.fabricWidth
            }}
            {{ row.fabricWidthUnit }}</span
          >
          <br />
          <span
            >{{ $l('table_label_fabricWeight') || '克重' }}：{{
              row.fabricWeight
            }}
            {{ row.fabricWeightUnit }}</span
          >
          <br />
          <span
            >{{ $l('table_label_fabricColor') || '颜色' }}：{{
              row.fabricColor
            }}</span
          >
        </div>
      </template>
      <template v-slot:totalArrivalQuantity="{ row }">
        <div>
          <span
            >{{ $l('table_label_totalArrivalQuantity') || '总米数' }}：{{
              row.totalArrivalQuantity || 0
            }}</span
          >
          <br />
          <span
            >{{ $l('table_label_totalArrivalRolls') || '总匹数' }}：{{
              row.totalArrivalRolls || 0
            }}</span
          >
        </div>
      </template>

      <template v-slot:totalInspectQuantity="{ row }">
        <div>
          <span
            >{{ $l('table_label_totalInspectQuantity') || '检验米数' }}：{{
              row.totalInspectQuantity || 0
            }}</span
          >
          <br />
          <span
            >{{ $l('table_label_totalActualQuantity') || '实测米数' }}：{{
              row.totalActualQuantity || 0
            }}</span
          >
          <br />
          <span
            >{{ $l('table_label_totalQualifiedQuantity') || '合格米数' }}：{{
              row.totalQualifiedQuantity || 0
            }}</span
          >
          <br />
          <span
            >{{ $l('table_label_totalDefectiveQuantity') || '不良米数' }}：{{
              row.totalDefectiveQuantity || 0
            }}</span
          >
        </div>
      </template>
      <template v-slot:totalInspectionRolls="{ row }">
        <div>
          <span
            >{{ $l('table_label_totalInspectionRolls') || '检验匹数' }}：{{
              row.totalInspectionRolls || 0
            }}</span
          >
          <br />
          <span
            >{{ $l('table_label_totalQualifiedRolls') || '合格匹数' }}：{{
              row.totalQualifiedRolls || 0
            }}</span
          >
          <br />
          <span
            >{{ $l('table_label_totalDefectiveRolls') || '不良匹数' }}：{{
              row.totalDefectiveRolls || 0
            }}</span
          >
        </div>
      </template>
      <template v-slot:totalDefectCount="{ row }">
        <div>
          <span
            >{{ $l('table_label_totalDefectCount') || '疵点总计' }}：{{
              row.totalDefectCount || 0
            }}</span
          >
          <br />
          <span
            >{{ $l('table_label_totalUtilizationRate') || '利用率' }}：{{
              row.totalUtilizationRate || 0
            }}%</span
          >
        </div>
      </template>

      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>
      <template v-slot:reporterNames="{ row }">
        <div v-if="row.reporterNames">
          <div
            v-for="(item, index) in row.reporterNames.split('、')"
            :key="index"
          >
            <span style="text-align: left;">{{ item }}</span>
          </div>
        </div>
      </template>

      <template v-slot:opt="{ row }">
        <ButtonGroup
          :options="opts"
          :row="row"
          :viewText="$l('INDEX.btn_tips_view_V2') || '查看详情'"
          @command="optCommand"
        />
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import ButtonGroup from './buttonGroup.vue'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: {
    ButtonGroup,
  },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    opts() {
      return tableOpts(this)
    },
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'quality-fabricInspectionReport-detail',
        params: { ...params, pageType },
        query,
      })
    },
    onCheckboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['col-opt']
      if (!filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true) || []
      const reserves = $table.getCheckboxReserveRecords(true) || []
      this.$emit('checkboxChange', data.concat(reserves))
    },
    optCommand({ opt, data }) {
      const { menuType, type } = opt
      switch (menuType) {
        case 'detail':
          this.openEditPage({
            pageType: 'detail',
            params: { code: data.inspectionCode },
            query: { inspectionNo: data.inspectionNo },
          })
          break
        case 'print':
          this.$emit('printData', { ...data, type })
          break
        case 'export':
          this.$emit('exportExcelData', { ...data, type })
          break
        case 'delete':
          this.del(data)
          break
        case 'rollback':
          this.rollback(data)
          break
      }
    },
    del(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(() => {
        this.loadingOpen()
        this.$api
          .fabricInspectionDelApi({ inspectionCode: row.inspectionCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(
              this.$l('INDEX.tips_delete_no') || '删除失败！',
            )
          })
      })
    },
    rollback(row) {
      this.$confirm(
        this.$l('tips_rollback') || '是否将该报告回退到待质检状态？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(() => {
        this.loadingOpen()
        this.$api
          .fabricInspectionRollbackApi({ inspectionCode: row.inspectionCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('tips_rollback_ok') || '回退成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(
              this.$l('tips_rollback_no') || '回退失败！',
            )
          })
      })
    },
    checCheckboxkMethod({ row }) {
      return ['R', 'T', 'Y'].includes(row.auditResultType) || ['R', 'T', 'S'].includes(row.status) 
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .status-tag {
  font-size: 12px;
  .el-tag--N {
    color: #101010;
    background-color: #f4f4f5;
    border: 1px solid #91939a;
  }
  .el-tag--Q {
    color: #e6a23c;
    background-color: #ffffff;
    border: 1px solid #f5dab1;
  }
  .el-tag--S {
    color: #70ce46;
    background-color: #e3f7d0;
    border: 1px solid #b7eb8f;
  }

  .el-tag--R {
    color: #007bff;
    background-color: #e9f3ff;
  }
  .el-tag--T {
    color: #f74852;
    background-color: #ffffff;
    border: 1px solid #f74852;
  }
  .el-tag--D {
    color: #f74852;
    background-color: #fff1f0;
    border: 1px solid #ffa39e;
  }
}
::v-deep .result-tag {
  font-size: 12px;

  .el-tag--Y {
    color: #70ce46;
    background-color: #e3f7d0;
    border: 1px solid #b7eb8f;
  }

  .el-tag--R {
    color: #e6a23c;
    background-color: #ffffff;
    border: 1px solid #f5dab1;
  }

  .el-tag--T {
    color: #f74852;
    background-color: #ffffff;
    border: 1px solid #f74852;
  }
}
</style>
